export default __webpack_public_path__ + "static/media/Waterfall1.bec99c24.jpg";